<p>Resubscribe to start applying again.</p>
<homey-form-buttons [buttons]="options()" class="justify-around mt-6" [small]="true" [submitFunction]="submitFunction">

</homey-form-buttons>
